import { Controller } from "@hotwired/stimulus"

export default class ContactFormController extends Controller {
  handleSubmit(event: CustomEvent) {
    if (event.detail.success) {
      // Close the modal
      const modal = this.element.closest(".modal")
      if (modal) {
        const bsModal = globalThis.bootstrap.Modal.getInstance(modal)
        if (bsModal) {
          bsModal.hide()
        }
      }
    }
  }
}
